import config from '../../config/index'

export const appUrl = config.appUrl
export const homePageUrl = config.homePageUrl

// homelight.com proxies this site at /hlm. A link to /#section resolves to
// homelight.com/#section, which is a different page. /hlm#section stays here.
const LANDING_ROOT = '/hlm'

export function landingPath(homePath) {
  const base = (homePath || '/').replace(/\/$/, '') || '/'
  if (base === '/' || base === '/homelight') return LANDING_ROOT
  return base
}

export function sectionHref(homePath, id) {
  return `${landingPath(homePath)}#${id}`
}

export const signupModalHref = sectionHref('/', 'signup-mod')
export const signupPageHref = `${appUrl}/auth/signup`
export const demoBookingUrl = 'https://success.homelight.com/meetings/anthony-de-la-cruz/homelight-listing-management-demo'
export const teamPlansUrl = 'https://success.homelight.com/meetings/anthony-de-la-cruz/hlm-team-plans'

export const footerLinks = {
  privacy: '/privacy',
  terms: '/terms',
  helpVideos: 'https://academy.disclosures.io/video-training',
  askQuestion: 'mailto:platform-support@homelight.com',
  feedback: 'https://survey.hsforms.com/1297WLSxLSEe4Yg5DcqlLIg2tp64',
  accessibilityEmail: 'mailto:platform-support@homelight.com',
  social: {
    facebook: 'https://www.facebook.com/gohomelight/',
    x: 'https://twitter.com/HomeLightApp',
    linkedin: 'https://www.linkedin.com/company/homelight',
    instagram: 'https://www.instagram.com/teamhomelight/?hl=en',
  },
}
